import ehsImg from "../../Images/ESR.png";
export function EHS() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title" style={{ fontSize: "19px" }}>
                Working towards creating a safer workplace &amp; clean
                environment…
              </h2>
              <p>
                We practice EHS (Environment, Health &amp; Safety) not only by
                just complying with regulations and industry standards, but also
                undertake initiatives to be better environmental stewards, and
                provide our employees with a safe and healthy workplace. The
                concept &amp; importance of EHS is continually stressed and
                extensively promoted as a part of our corporate culture.
              </p>
              <p>
                Our core values and mission revolve around “care” and we
                consciously ensure that we engage in efforts to fulfill our
                responsibility towards the safety of the people who work for us,
                our stakeholders and the environment. This had led us to
                implement our EHS policy which highlights and keeps us committed
                to our allegiance of manufacturing products in a manner that
                keeps our people safe and the environment clean. The key
                processes comprise regular safety surveillance, inspections and
                audits; permit to work system for operational/maintenance
                safety; fire prevention and protection activities; operation of
                the Effluent Treatment Plant (ETP)/MVR; disposal activities
                related to hazardous wastes; and regular monitoring of the
                environment, internally and also through approved laboratories.
              </p>
              <p>
                We are continually engaged in evaluating and improving our
                facility and systems to enhance safety parameters along with
                keeping a tab over permissible limits of emission &amp; ambient
                air monitoring, noise level monitoring &amp; effluent and
                hazardous waste management. Close cooperation and adherence to
                guidelines between all units and individuals is how we aim at
                maintaining high standards of environment protection and safety
                at all the facilities. Monthly reports address EHS initiatives;
                compliance and various records under statutory requirements;
                training of employees; interaction with residents’ associations
                and adjacent communities; and observance or celebration of
                National Safety Day, National Fire Safety Day and World
                Environment Day, among others, in order to promote EHS awareness
                amongst employees. We accord the highest priority to hygiene
                monitoring at the workplace and health assessment of all
                employees at facilities. A monthly and annual report is
                diligently submitted by us to the Gujarat Pollution Control
                Board (GPCB).
              </p>
            </div>
          </div>

          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={ehsImg} alt="EHS" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
